/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopGuildLeaderboard } from './TopGuildLeaderboard';
import {
    TopGuildLeaderboardFromJSON,
    TopGuildLeaderboardFromJSONTyped,
    TopGuildLeaderboardToJSON,
    TopGuildLeaderboardToJSONTyped,
} from './TopGuildLeaderboard';

/**
 * 
 * @export
 * @interface GetTopGuildsLeaderboardResponse
 */
export interface GetTopGuildsLeaderboardResponse {
    /**
     * 
     * @type {Array<TopGuildLeaderboard>}
     * @memberof GetTopGuildsLeaderboardResponse
     */
    guilds: Array<TopGuildLeaderboard>;
}

/**
 * Check if a given object implements the GetTopGuildsLeaderboardResponse interface.
 */
export function instanceOfGetTopGuildsLeaderboardResponse(value: object): value is GetTopGuildsLeaderboardResponse {
    if (!('guilds' in value) || value['guilds'] === undefined) return false;
    return true;
}

export function GetTopGuildsLeaderboardResponseFromJSON(json: any): GetTopGuildsLeaderboardResponse {
    return GetTopGuildsLeaderboardResponseFromJSONTyped(json, false);
}

export function GetTopGuildsLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTopGuildsLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'guilds': ((json['guilds'] as Array<any>).map(TopGuildLeaderboardFromJSON)),
    };
}

export function GetTopGuildsLeaderboardResponseToJSON(json: any): GetTopGuildsLeaderboardResponse {
    return GetTopGuildsLeaderboardResponseToJSONTyped(json, false);
}

export function GetTopGuildsLeaderboardResponseToJSONTyped(value?: GetTopGuildsLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guilds': ((value['guilds'] as Array<any>).map(TopGuildLeaderboardToJSON)),
    };
}

